var Vue = require('vue');

let bus = new Vue();

module.exports =  bus;



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/bus.js